import React from 'react';
import './FlippingComponent.scss';
import PropTypes from 'prop-types';

const flipper = props => {
  const cardRef = React.createRef();
  const flipHandler = () => {
    const card = cardRef.current;
    card.classList.toggle('is-flipped');
    card.firstElementChild.setAttribute('tabindex', '-1');
    card.firstElementChild.setAttribute('disabled', 'true');
    card.lastElementChild.focus();
    if (props.onCardTurned) props.onCardTurned();
  };
  const { faceBack, faceFront, faceFrontProps = {}, faceBackProps = {}, cardDescriptions } = props;
  return (
    <div className="scene">
      <div className="card" ref={cardRef}>
        <button
          className="gss-button card__face card__face--front"
          onClick={flipHandler}
          id="flip-card-front"
          aria-label={cardDescriptions?.cardFrontDescription || ''}
          {...faceFrontProps}
        >
          {faceFront}
        </button>
        <button
          className="gss-button card__face card__face--back"
          onClick={faceBack ? () => null : props.onCardTurned}
          id="flip-card-back"
          tabIndex="-1"
          aria-label={cardDescriptions?.cardBackDescription || ''}
          {...faceBackProps}
        >
          {faceBack}
        </button>
      </div>
    </div>
  );
};

flipper.propTypes = {
  faceFront: PropTypes.element,
  faceBack: PropTypes.element,
  onCardTurned: PropTypes.func,
  cardDescriptions: PropTypes.object,
  faceFrontProps: PropTypes.object,
  faceBackProps: PropTypes.object
};

export default flipper;
